import GeneralInfoForm from './general-info-form'

export default GeneralInfoForm;